import { Action } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { IMigration, IAccountMigration, IMigrationStatus } from '@shared';

export enum MigrationsActionTypes {
  GetMigrations = '[Migrations] Get Migrations',
  GetMigrationsSuccess = '[Migrations] Get Migrations Success',
  GetMigrationsFail = '[Migrations] Get Migrations Fail',
  GetAccountMigrations = '[Migrations] Get Account Migrations',
  GetAccountMigrationsSuccess = '[Migrations] Get Account Migrations Success',
  GetAccountMigrationsFail = '[Migrations] Get Account Migrations Fail',
  UpdateSearchValues = '[Migrations] Update Search Values',
  GetMigrationReport = '[Migrations] Get Migration Report',
  GetMigrationReportSuccess = '[Migrations] Get Migration Report Success',
  GetMigrationReportFail = '[Migrations] Get Migration Report Fail',
  GetAccountMigrationProgress = '[Migrations] Get Account Migration Progress',
  GetAccountMigrationProgressSuccess = '[Migrations] Get Account Migration Progress Success',
  GetAccountMigrationProgressFail = '[Migrations] Get Account Migration Progress Fail',
  GetAccountPASMigrations = '[Migrations] Get Account PAS Migration',
  GetAccountPASMigrationsSuccess = '[Migrations] Get Account PAS Migration Success',
  GetAccountPASMigrationsFail = '[Migrations] Get Account PAS Migration Fail',
}

export class GetMigrations implements Action {
  readonly type = MigrationsActionTypes.GetMigrations;
  constructor() {}
}

export class GetMigrationsSuccess implements Action {
  readonly type = MigrationsActionTypes.GetMigrationsSuccess;
  constructor(public payload: IMigration[]) {}
}

export class GetMigrationsFail implements Action {
  readonly type = MigrationsActionTypes.GetMigrationsFail;
  constructor(public payload: HttpErrorResponse) {}
}

export class GetAccountMigrations implements Action {
  readonly type = MigrationsActionTypes.GetAccountMigrations;
  constructor(
    public payload: {
      accountId: string;
      proAccountId: string;
      startDate: string;
    },
  ) {}
}

export class GetAccountMigrationsSuccess implements Action {
  readonly type = MigrationsActionTypes.GetAccountMigrationsSuccess;
  constructor(public payload: IAccountMigration[]) {}
}

export class GetAccountMigrationsFail implements Action {
  readonly type = MigrationsActionTypes.GetAccountMigrationsFail;
  constructor(public payload: HttpErrorResponse) {}
}

export class UpdateSearchValues implements Action {
  readonly type = MigrationsActionTypes.UpdateSearchValues;
  constructor(
    public payload: {
      query: string;
      dateInterval: number;
      stateFilter: string[];
    },
  ) {}
}

export class GetMigrationReport implements Action {
  readonly type = MigrationsActionTypes.GetMigrationReport;
  constructor(public payload: IMigration) {}
}

export class GetMigrationReportSuccess implements Action {
  readonly type = MigrationsActionTypes.GetMigrationReportSuccess;
}

export class GetMigrationReportFail implements Action {
  readonly type = MigrationsActionTypes.GetMigrationReportFail;
  constructor(public payload: void) {}
}

export class GetAccountMigrationProgress implements Action {
  readonly type = MigrationsActionTypes.GetAccountMigrationProgress;
  constructor(
    public payload: {
      oneAccountId: string;
      proAccountId: string;
      sectionId: string;
    },
  ) {}
}

export class GetAccountMigrationProgressSuccess implements Action {
  readonly type = MigrationsActionTypes.GetAccountMigrationProgressSuccess;
  constructor(public payload: { progress: IMigrationStatus }) {}
}

export class GetAccountMigrationProgressFail implements Action {
  readonly type = MigrationsActionTypes.GetAccountMigrationProgressFail;
}

export class GetAccountPASMigrations implements Action {
  readonly type = MigrationsActionTypes.GetAccountPASMigrations;
  constructor(public payload: { accountId: string; proAccountId: string }) {}
}

export class GetAccountPASMigrationsSuccess implements Action {
  readonly type = MigrationsActionTypes.GetAccountPASMigrationsSuccess;
  constructor(public payload: { migration: IMigration }) {}
}

export class GetAccountPASMigrationsFail implements Action {
  readonly type = MigrationsActionTypes.GetAccountPASMigrationsFail;
}

export type MigrationsActions =
  | GetMigrations
  | GetMigrationsSuccess
  | GetMigrationsFail
  | GetAccountMigrations
  | GetAccountMigrationsSuccess
  | GetAccountMigrationsFail
  | UpdateSearchValues
  | GetMigrationReport
  | GetMigrationReportSuccess
  | GetMigrationReportFail
  | GetAccountMigrationProgress
  | GetAccountMigrationProgressSuccess
  | GetAccountMigrationProgressFail
  | GetAccountPASMigrations
  | GetAccountPASMigrationsSuccess
  | GetAccountPASMigrationsFail;
